import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useMenuStore = defineStore('gallery/menu', () => {
  const _dataPlace = [
    { id: 1, enable: true },
    { id: 2, enable: true },
  ]

  const _dataCategory = [
    { id: 1, enable: true },
    { id: 2, enable: true },
    { id: 3, enable: true },
    { id: 4, enable: true },
    { id: 5, enable: true },
  ]

  // State -----------------------------------------
  const place = ref(1)
  const category = ref(1)

  // Getters ---------------------------------------
  const placeMenus = computed(() => {
    return _dataPlace.map((e) => {
      e.actived = place.value === e.id
      return e
    })
  })

  const categoryMenus = computed(() => {
    return _dataCategory.map((e) => {
      e.actived = category.value === e.id
      e.enable = place.value == 2 && e.id == 2 ? false : true //hardcode fix menu
      return e
    })
  })

  // Actions ---------------------------------------
  function $reset() {
    place.value = 1
    category.value = 1
  }

  function enableAllMenus() {
    _dataPlace.forEach((e) => {
      e.enable = true
    })
    _dataCategory.forEach((e) => {
      e.enable = true
    })
  }

  function changeMenu(placeId, categoryId) {
    place.value = placeId
    category.value = categoryId
  }

  function changeMenuPlace(id) {
    place.value = id
    category.value = 1
  }

  function changeMenuCategory(id) {
    category.value = id
  }

  // Main Setup ------------------------------------

  // -----------------------------------------------
  return {
    place,
    category,
    placeMenus,
    categoryMenus,
    $reset,
    enableAllMenus,
    changeMenu,
    changeMenuPlace,
    changeMenuCategory,
  }
})
